// set maximum days one year ago considering if current year is leap year
export const MAXIMUM_DAYS =
  new Date().getFullYear() % 4 === 0 && new Date().getMonth() >= 3 ? 365 : 364; // Todo: check if it's better to change the api instead

export enum FilterReportsSelection {
  START_OF_MONTH = 'startOfMonth',
  LAST_24_HOURS = 'last24Hours',
  LAST_7_DAYS = 'last7Days',
  LAST_30_DAYS = 'last30Days',
  LAST_90_DAYS = 'last90Days',
  LAST_YEAR = 'lastYear',
  CUSTOM_RANGE = 'customRange',
}

export const DATE_SELECTION_OPTIONS = [
  { label: 'Current month', value: FilterReportsSelection.START_OF_MONTH },
  { label: 'Last 24 hours', value: FilterReportsSelection.LAST_24_HOURS },
  { label: 'Last 7 days', value: FilterReportsSelection.LAST_7_DAYS },
  { label: 'Last 30 days', value: FilterReportsSelection.LAST_30_DAYS },
  { label: 'Last 90 days', value: FilterReportsSelection.LAST_90_DAYS },
  { label: 'Last year', value: FilterReportsSelection.LAST_YEAR },
  { label: 'Custom range', value: FilterReportsSelection.CUSTOM_RANGE },
];
